import React, { useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const ImagePreviewForUpload = ({
  src,
  onDelete,
  ...rest
}: {
  src: any;
  width?: any;
  height?: any;
  onDelete?: () => void;
  className?: any;
}) => {
  const [isFits, setisFits] = useState<string>();
  return (
    <React.Fragment>
      {isFits ? (
        <Lightbox
          mainSrc={src}
          enableZoom={true}
          onCloseRequest={() => {
            setisFits(undefined);
          }}
        />
      ) : null}
      <div>
        {onDelete && (
          <div
            className="w-100"
            style={{
              width: rest.width ?? 70,
              position: "relative",
            }}
          >
            <i
              className="mdi mdi-close-thick cursor-pointer"
              onClick={() => {
                onDelete && onDelete();
              }}
              style={{
                position: "absolute",
                right: -3,
                top: -3,
                fontSize: 12,
                padding: 2,
                backgroundColor: "red",
                color: "white",
                borderRadius: "80%",
                cursor: "pointer",
              }}
            />
          </div>
        )}
        <img
          alt=""
          src={src}
          onClick={() => setisFits(src)}
          {...rest}
          style={{ cursor: "pointer", borderRadius: 6 }}
        />
      </div>
    </React.Fragment>
  );
};
export default ImagePreviewForUpload;
